var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "welcome-wrapper" },
    [
      [
        _c("img", {
          staticClass: "welcome-main",
          attrs: { src: _vm.images[0], alt: "" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "welcome-secondary",
          attrs: { src: _vm.images[1], alt: "" }
        })
      ],
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "hide-btn",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.hideImg($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.seconds) + " 跳过")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdcedba4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdcedba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Welcome.vue
// module id = K390
// module chunks = 15